import { Input,  } from 'antd';


const TextType = ({value, variant}) => {
    return (
        <div>
             <Input value={value} variant={variant} readOnly  style={{ pointerEvents: 'none', }}/>
        </div>
    ); 
};

export default TextType;